import { CommentAttachment } from 'server/types';
import { MAX_COMMENT_FILES } from 'shared/consts';

export const MAX_FILES = MAX_COMMENT_FILES;

type ClipboardLike = Pick<DataTransfer, 'files' | 'types' | 'getData'>;

export function pastedFiles(clipboard: ClipboardLike | null | undefined) {
  if (!clipboard?.files.length) {
    return [];
  }
  const files = Array.from(clipboard.files);
  const html = clipboard.getData('text/html');
  if (html) {
    return visibleText(html) ? [] : files;
  }
  const names = files.map((file) => file.name);
  const lines = clipboard
    .getData('text/plain')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  if (lines.some((line) => !names.includes(line) && !names.includes(fileName(line)))) {
    return [];
  }
  return files;
}

function visibleText(html: string) {
  return html
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/<(style|script|head)[\s\S]*?<\/\1>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;|&#160;/g, ' ')
    .trim();
}

function fileName(path: string) {
  return path.split(/[\\/]/).pop() || path;
}

export function roomFor(attachments: CommentAttachment[], uploadCount: number) {
  return Math.max(0, MAX_FILES - attachments.length - uploadCount);
}

export function addLibraryAttachments(
  current: CommentAttachment[],
  picks: CommentAttachment[],
  room: number,
) {
  let result = current;
  let added = 0;
  let skipped = 0;
  picks.forEach((pick) => {
    const existing = result.find((a) => a.id === pick.id);
    if (existing?.isDeleted) {
      result = result.map((a) => (a.id === pick.id ? { ...a, isDeleted: false } : a));
      return;
    }
    if (existing) {
      return;
    }
    if (added >= room) {
      skipped++;
      return;
    }
    added++;
    result = [...result, pick];
  });
  return { attachments: result, skipped };
}

export function removeAttachment(current: CommentAttachment[], id: UUID, savedIds: Set<UUID>) {
  if (savedIds.has(id)) {
    return current.map((a) => (a.id === id ? { ...a, isDeleted: true } : a));
  }
  return current.filter((a) => a.id !== id);
}

export function addUploadedAttachment(current: CommentAttachment[], attachment: CommentAttachment) {
  return addLibraryAttachments(current, [attachment], 1).attachments;
}

export function hasFiles(e: DragEvent) {
  return !!e.dataTransfer?.types.includes('Files');
}
